import React, { useEffect, useState } from 'react';
import * as S from './styles';
import iconeDelete from '../../midia/delete.svg'

export function ListaItemLS(props){
    function BtDeletarProd(t){
        const bb = props.listaItemLS.filter(e=> e.codigo !== t.codigo);
        localStorage.setItem(props.nomeLS, JSON.stringify(bb));
        if(bb){
            props.setInfor("listaItemLS", bb)
        };
    };

    const [porTipo, setfiltTipo] = useState([]);
    

    useEffect(() => {
        const tipo = props.listaItemLS.map(t => t.tipo);
        const tipoUnicos = Array.from(new Set(tipo));        

        for(let i = 0; i < tipoUnicos.length; i++){
            const FiltraTT = props.listaItemLS.filter(e => e.tipo == tipoUnicos[i]);
            const listaTipo = {
                tipo: tipoUnicos[i],
                lista: FiltraTT
            };
            
            console.log(listaTipo)
        };

    }, [props.listaItemLS])

    
        
    

    //###############################
    return(
        <S.bodyresult>    
            {/* {porTipo.map((t, key)=>(
                <>
                <span> {t.tipo} </span>
                <S.Lista className='listaPagamento' key={key}>   
                    <span> {t.data} </span>      
                                
                    <span> {t.nomeItem} </span>
                    <span style={{"justifyContent":"flex-start"}}>{parseFloat(t.valor).toLocaleString('pt-br',{style: 'currency', currency: 'BRL'})}</span>
                    <div>
                        <img 
                        style={{'width':'12px'}}
                        src={iconeDelete} 
                        alt='detalhe' 
                        onClick={()=>BtDeletarProd(t)} 
                        />
                    </div>
                </S.Lista>
                </>
            ))} */}
        </S.bodyresult>
    )
};